export const responsive = {
  desktopFullHD: {
    breakpoint: { max: 3000, min: 1700 },
    items: 4,
    slidesToSlide: 1,
    partialVisibilityGutter: 40
  },
  desktopHD: {
    breakpoint: { max: 1700, min: 1200 },
    items: 3,
    slidesToSlide: 1,
    partialVisibilityGutter: 40
  },
  desktop: {
    breakpoint: { max: 1350, min: 1070 },
    items: 3,
    slidesToSlide: 1,
    partialVisibilityGutter: -50
  },
  iPad: {
    breakpoint: { max: 1070, min: 860 },
    items: 2,
    slidesToSlide: 1,
    partialVisibilityGutter: 30
  },
  tablet: {
    breakpoint: { max: 860, min: 806 },
    items: 2,
    slidesToSlide: 1,
    partialVisibilityGutter: 0
  },
  minTablet: {
    breakpoint: { max: 806, min: 540 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 100
  },
  mobile: {
    breakpoint: { max: 540, min: 0 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 0
  }
};